// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"69dede39","862":"8aef6ee2"}[chunkId] + ".chunk.js";
};